import type { AxiosInstance } from 'axios'
import type { Router } from 'vue-router'
import type { AuthStore } from '../stores/auth'

export function setupAuthInterceptors(apiClient: AxiosInstance, getAuthStore: () => AuthStore, router: Router) {
  const publicRoutes = ['/Auth/login', '/Auth/register', '/Auth/forgot-password']

  apiClient.interceptors.request.use(
    (config) => {
      // Skip auth check for public routes
      if (config.url && publicRoutes.some((route) => config.url?.includes(route))) {
        return config
      }

      const authStore = getAuthStore()
      const token = authStore.token

      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    },
  )

  apiClient.interceptors.response.use(
    (response) => {
      return response
    },
    async (error) => {
      if (error.response?.status === 401) {
        const authStore = getAuthStore()
        authStore.logout()
        await router.push({ name: 'login' })
      }
      return Promise.reject(error)
    },
  )
}
